import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { ApiMethods, Permission, PermissionConfigurationBase, PermissionConfiguration } from '../../models/permission.model';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PermsService {
  permissions: Map<string, Permission[]>;

  constructor(private h: HttpClientService) {
    this.permissions = new Map<string, Permission[]>();
  }

  get(ms_base_url: string) {
    return this.h.get(ms_base_url + '/permissions/api')
      .map(res => {
        this.permissions[ms_base_url] = res;
      });
  }

  check(conf: PermissionConfiguration): Observable<boolean> {
    if (conf && conf.ms_base && conf.operation) {

      return this.h.get(conf.ms_base + '/permissions/api').map(res => {
        this.permissions[conf.ms_base] = res;

        const permission = this._extractPermission(conf);

        const result = (
          (permission && conf.method === ApiMethods.GET && permission.allowsGET)
          || (permission && conf.method === ApiMethods.POST && permission.allowsPOST)
          || (permission && conf.method === ApiMethods.PUT && permission.allowsPUT)
          || (permission && conf.method === ApiMethods.DELETE && permission.allowsDELETE)
        );

        return result;

      });
    } else {
      return Observable.of(true);
    }
  }

  getPermissions(conf: PermissionConfigurationBase): Observable<Array<Permission>> {    
    if (conf && conf.ms_base && conf.operation) {
      return this.h.get(conf.ms_base + '/permissions/api');
    }
    else{
      return Observable.of(null);
    }
  }
  getPermission(conf: PermissionConfigurationBase): Observable<Permission> {
    
    if (conf && conf.ms_base && conf.operation) {

      return this.h.get(conf.ms_base + '/permissions/api').map(res => {        
        this.permissions[conf.ms_base] = res;

        const permission = this._extractPermission(conf);

        return permission ? permission : null;

      });
    } else {
      return Observable.of(null);
    }
  }

  private _extractPermission(conf: PermissionConfigurationBase) {
    const permission: Permission = this.permissions[conf.ms_base].find(function (e) {
      if (e.operationName === conf.operation) {
        return e;
      }
    });
    return permission;
  }

  getLoyaltyPermission(){
    return this.h.get('koncentro-loyalty/permissions/api');
  }  
  getCustomerPermission(){
    return this.h.get('koncentro-customers/permissions/api');
  }  
  checkPermission(permissions: Array<Permission>,permissionConf: PermissionConfiguration): boolean{
    let res = false;

    if (permissionConf && permissionConf.ms_base && permissionConf.operation) {

      if(permissions && permissionConf){
        let indexFound = permissions.findIndex(x=>x.operationName == permissionConf.operation);

        if(indexFound > -1){
          if(         
            (permissionConf.method == ApiMethods.GET && permissions[indexFound].allowsGET == true) ||
            (permissionConf.method == ApiMethods.POST && permissions[indexFound].allowsPOST == true) ||
            (permissionConf.method == ApiMethods.PUT && permissions[indexFound].allowsPUT == true) ||
            (permissionConf.method == ApiMethods.DELETE && permissions[indexFound].allowsDELETE == true)
            ){
              res = true;
            }
        }        
      }
    }

    return res;
  }
  getCommonPermission(){
    return this.h.get('koncentro-common/permissions/api');
  }

  getPromoPermission(){
    return this.h.get('koncentro-promo/permissions/api');
  }    
}




// WEBPACK FOOTER //
// ./src/app/services/utils/perms.service.ts